import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from "react-router-dom";
import Dashboard_svg from "../assets/image/sidebarIcons/Dashboard.svg";
import Education_svg from "../assets/image/sidebarIcons/Education.svg";
import { NavigationRoutes } from '../../constant/Routes';
import localStorageServices from '../../services/LocalStorage';
import { LocalStorageKeys } from '../../constant/LocalStorageKeys';
import { access } from '../../constant/Constants';
// import Others_svg from "../assets/image/sidebarIcons/Others.svg";

const SidebarLinks = ({ Toggle }) => {

    const [active_dropdown, setActiveDropdown] = useState('');
    const [active_tab, setActiveTab] = useState('');
    const [active_menu, setActiveMenu] = useState({ dashboard: false, education: false, account: false, other: false, misc: false });

    const currentLocation = useLocation().pathname;
    const base = '/admin_dashboard'
    // const type = localStorageServices.getItem(LocalStorageKeys.userInfo).type;
    // const accessGot = (localStorageServices.getItem(LocalStorageKeys.userInfo).access).split(",");
    // console.log("keys--------------",localStorageServices.getItem(LocalStorageKeys.userInfo));

    const userInfo = localStorageServices.getItem(LocalStorageKeys.userInfo);

    const type = userInfo?.type ?? "";
    const access1 = userInfo?.access || "";
    const accessGot = access1.split(",");

    const haveAccess = (featureName) => {
        if (type === "0") {
            return true;
        }
        else if (type === "1" && accessGot.includes(featureName)) {
            return true;
        }
        else {
            return false;
        }
    }

    const DLink1 = (currentLocation, name, url, icon, id, parentId) => {




        useEffect(() => {

            if (currentLocation === (url ? base + '/' + url : base)) {
                // console.log(changeTab1())
            }

        }, [currentLocation, id, parentId, url])


        return (
            <NavLink

                to={url}
                id={id}
                className={`sidebar_options_link ${active_dropdown === id ? "sidebar_options_active" : ""} m-0 w-100 pr-1`}
                onClick={() => {
                    if (Toggle) {

                        document.getElementById('dashboard-collapse').classList.remove('show');
                        document.getElementById('user-list-collapse').classList.remove('show');
                        document.getElementById('vehicle-listing-collapse').classList.remove('show');
                        setActiveMenu((pre) => {

                            return {
                                dashboard: false,
                                account: false,
                                education: false
                            }
                        })
                    }
                    setActiveDropdown(id);
                    setActiveTab(parentId)
                }}
            >
                <img src={icon} className=" Sidebar_text sidebar_icons" alt="" />
                <span className="text-dark " style={{ fontSize: "0.9rem" }}>{name}</span>
            </NavLink>
        );
    };

    return (



        <div>
            {/* ---- first dropdown---- */}
            {/* {haveAccess(access.dashboard)&&<div className="flex-shrink-0">
                    <ul className="list-unstyled m-0">
                        <a
                            onClick={() => {


                                document.getElementById('user-list-collapse').classList.remove('show');
                        
                                setActiveMenu((pre) => {

                                    return {
                                        dashboard: true,
                          
                                    }
                                })

                                setActiveMenu((pre) => {

                                    return {
                                        ...pre,
                                        dashboard: !active_menu.dashboard
                                    }
                                })

                            }}
                            href="#!"
                            style={Toggle ?
                                !active_menu.dashboard ?
                                    { width: '60px', borderBottomRightRadius: `${active_menu.dashboard === true ? '0px' : ''}` }
                                    :
                                    { borderBottomRightRadius: `${active_menu.dashboard === true ? '0px' : ''}` }
                                : { borderBottomRightRadius: `${active_menu.dashboard === true ? '0px' : ''}` }}
                            className={`data-toggle sidebar_options_drop d-flex justify-content-between ${active_tab === 'dashboard-collapse-btn' ? 'active_tab' : ''} ${active_menu.dashboard === true ? 'active_tab' : ''} `}
                            role="button"
                            id="dashboard-collapse-btn"
                            data-bs-toggle="collapse" data-bs-target="#dashboard-collapse" aria-expanded="true"
                        >
                            <div>
                                <img
                                    src={Dashboard_svg}
                                    className="Sidebar_text  sidebar_icons"
                                    alt=""
                                />
                                <span className="text-dark " style={

                                    Toggle ?
                                        !active_menu.dashboard ? { display: 'none', fontSize: "0.9rem" } :
                                            { fontSize: "0.9rem" } : { fontSize: "0.9rem" }}>Dashboard</span>
                            </div>
                            {!Toggle && <i className={`fas fa-chevron-down mr-3 ${active_menu.dashboard ? "toggle-up" : "toggle-down"}`}></i>}
                        </a>


                        <div className="collapse collapse_superadmin p-0" id="dashboard-collapse">
                            <ul className={`${Toggle ? 'btn-toggle-nav-hide' : 'btn-toggle-nav'}  list-unstyled `}>
                                <li className="dropdown_items_div ml-1">

                                    {DLink1(currentLocation, "Dashboard", `${NavigationRoutes.ADMIN_DASHBOARD}`, "ok", 'Dashboard', 'dashboard-collapse-btn')}
                                  
                                </li>
                            </ul>
                        </div>
                    </ul>
                </div>} */}


            {/* ---- secound dropdown---- */}
            <div className="flex-shrink-0">
                <ul className="list-unstyled m-0">
                    {/* <a
                            onClick={() => {
                                document.getElementById('dashboard-collapse').classList.remove('show');
                         
                                setActiveMenu((pre) => {

                                    return {
                            
                                        education: true
                                    }
                                })
                                setActiveMenu((pre) => { return { ...pre, education: !active_menu.education } })
                            }}
                            href="#!"
                        
                            style={Toggle ?
                                !active_menu.education ?
                                    { width: '60px', borderBottomRightRadius: `${active_menu.education === true ? '0px' : ''}` }
                                    :
                                    { borderBottomRightRadius: `${active_menu.education === true ? '0px' : ''}` }
                                : { borderBottomRightRadius: `${active_menu.education === true ? '0px' : ''}` }}
                            className={`data-toggle sidebar_options_drop d-flex justify-content-between ${active_tab === 'user-list-collapse-btn' ? 'active_tab' : ''} ${active_menu.education === true ? 'active_tab' : ''} `}
                            role="button"
              
                            id="user-list-collapse-btn"
                            data-bs-toggle="collapse" data-bs-target="#user-list-collapse" aria-expanded="true"
                        >
                            <div>
                                <img
                                    src={Education_svg}
                                    className="  Sidebar_text  sidebar_icons"
                                    alt=""
                                />
                                <span style={
                                    Toggle ?
                                        !active_menu.education ? { display: 'none', fontSize: "0.9rem", } :
                                            { fontSize: "0.9rem" } : { fontSize: "0.9rem" }} className="text-dark ">User listing</span>
                            </div>
                            {!Toggle && <i className={`fas fa-chevron-down mr-3 ${active_menu.education ? "toggle-up" : "toggle-down"}`}></i>}
                        </a>

                           <div className="collapse collapse_superadmin" id="user-list-collapse">
                            <ul className={`${Toggle ? 'btn-toggle-nav-hide' : 'btn-toggle-nav'}  list-unstyled `}>
                                <li className="dropdown_items_div ml-1">
                                    {DLink1(currentLocation, "All Users", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.VERIFIED_USER_LISTING}`, "ok", "user-lisitng-1", 'user-list-collapse-btn')}

                                </li>
                            </ul>
                        </div> */}



                    {haveAccess(access.dashboard) && <li className="dropdown_items_div ml-1">
                        {DLink1(currentLocation, "Marketplace Pulse", `${NavigationRoutes.ADMIN_DASHBOARD}`, Dashboard_svg, 'Marketplace Pulse', 'pulse-collapse-btn')}
                    </li>}
                    {haveAccess(access.dashboard) && <li className="dropdown_items_div ml-1">
                        {DLink1(currentLocation, "Analytics Dashboard", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.DASHBOARD}`, Dashboard_svg, 'Analytics Dashboard', 'dashboard-collapse-btn')}
                    </li>}
                    {haveAccess(access.dashboard) && <li className="dropdown_items_div ml-1">
                        {DLink1(currentLocation, "Ad Views by Month", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.VIEWS_TREND}`, Dashboard_svg, 'Ad Views by Month', 'viewstrend-collapse-btn')}
                        {DLink1(currentLocation, "Heat map", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.ADVERTISER_MAP}`, Dashboard_svg, 'Heat map', 'advertisermap-collapse-btn')}
                    </li>}

                    {haveAccess(access.user) && <li className="dropdown_items_div ml-1">
                        {DLink1(currentLocation, "All Users", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.VERIFIED_USER_LISTING}`, Education_svg, "user-lisitng-1", 'user-list-collapse-btn')}

                    </li>}



                    {haveAccess(access.admin) && <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Admin Management", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.ACTIVE_ADMIN}`, Education_svg, "admin-lisitng-1", 'admin-list-collapse-btn')}


                    </li>}


                    {/* ---- Dealers Dropdown ---- */}
                    {haveAccess(access.dashboardDealer) && <div className="flex-shrink-0">
                        <ul className="list-unstyled m-0">
                            <li>
                                <a
                                    onClick={() => {
                                        document.getElementById('dashboard-collapse')?.classList.remove('show');
                                        setActiveMenu((pre) => ({
                                            ...pre,
                                            settings: !active_menu.settings
                                        }));
                                        setActiveTab('settings-collapse-btn');
                                    }}
                                    href="#!"
                                    style={
                                        Toggle
                                            ? !active_menu.settings
                                                ? { width: '60px', borderBottomRightRadius: '0px', paddingRight: "10px" }
                                                : { paddingRight: "10px" }
                                            : { paddingRight: "10px" }
                                    }
                                    className={`data-toggle sidebar_options_drop d-flex justify-content-between ${active_tab === 'settings-collapse-btn' ? 'active_tab' : ''} ${active_menu.settings ? 'active_tab' : ''} m-0 w-100`}
                                    role="button"
                                    id="settings-collapse-btn"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#settings-collapse"
                                    aria-expanded="true"
                                >
                                    <div>
                                        <img src={Education_svg} className="Sidebar_text sidebar_icons" alt="" />
                                        <span className="text-dark" style={Toggle && !active_menu.settings ? { display: 'none', fontSize: "0.9rem" } : { fontSize: "0.9rem" }}>
                                            Dealer Portal
                                        </span>
                                    </div>
                                    {!Toggle && <i className={`fas fa-chevron-down mr-3 ${active_menu.settings ? "toggle-up" : "toggle-down"}`}></i>}
                                </a>
                            </li>

                            <div className="collapse collapse_superadmin p-0 m-0 w-100" id="settings-collapse">
                                <ul className={`${Toggle ? 'btn-toggle-nav-hide' : 'btn-toggle-nav'} list-unstyled`}>


                                    <li className="dropdown_items_div ml-1">
                                        {DLink1(currentLocation, "Dealer Dashboard", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.DEALER_DASHBOARD}`, Education_svg, "content-settings-2", 'settings-collapse-btn')}
                                    </li>


                                    <li className="dropdown_items_div ml-1">
                                        {DLink1(currentLocation, "Dealers", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.DEALER_LISTING}`, Education_svg, "content-settings-1", 'settings-collapse-btn')}
                                    </li>






                                </ul>
                            </div>
                        </ul>
                    </div>}




                    <li className="dropdown_items_div ml-1">
                        {DLink1(currentLocation, "Pending Dealers", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.PENDING_DEALERS}`, Education_svg, "pending-dealers-1", "settings-collapse-btn")}
                    </li>

                    {haveAccess(access.tier) && <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Dealer Tier", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.TIERS}`, Education_svg, "tiers-lisitng-1", 'tiers-list-collapse-btn')}


                    </li>}




                    {haveAccess(access.categories) && <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Categories Management", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.CATEGORIES}`, Education_svg, "categories-lisitng-1", 'categories-list-collapse-btn')}


                    </li>}

                    {haveAccess(access.categories) && <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Filter Management", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.FILTER_MANAGEMENT}`, Education_svg, "filter-management-1", 'filter-management-collapse-btn')}


                    </li>}


                    {haveAccess(access.plan) && <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Plan Management", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.PLANS}`, Education_svg, "plans-lisitng-1", 'plans-list-collapse-btn')}


                    </li>}

                    {haveAccess(access.plan) && <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Advert Pricing", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.AD_PRICING}`, Education_svg, "ad-pricing-lisitng-1", 'ad-pricing-list-collapse-btn')}


                    </li>}

                    {haveAccess(access.plan) && <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Advert Features", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.AD_FEATURES}`, Education_svg, "ad-features-lisitng-1", 'ad-features-list-collapse-btn')}


                    </li>}


                    {haveAccess(access.billing) && <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Payments & Subscriptions", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.BILLING}`, Education_svg, "billing-lisitng-1", 'billing-list-collapse-btn')}


                    </li>}

                    {haveAccess(access.billing) && <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Discount Codes", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.DISCOUNT_CODES}`, Education_svg, "promos-lisitng-1", 'promos-list-collapse-btn')}


                    </li>}

                    {haveAccess(access.soldAds) && <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Sold Ads", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.SOLD_ADS}`, Education_svg, "sold-ads-lisitng-1", 'sold-ads-list-collapse-btn')}


                    </li>}




                    {haveAccess(access.removedExpiredAds) && <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Removed/Expired Ads", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.REMOVED_EXPIRED_ADS}`, Education_svg, "removed-expired-ads-lisitng-1", 'removed-expired-ads-list-collapse-btn')}


                    </li>}



                    {haveAccess(access.bank) && <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Bank Management", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.BANKS}`, Education_svg, "banks-lisitng-1", 'banks-list-collapse-btn')}


                    </li>}


                    {haveAccess(access.vehicle) &&
                        <li className="dropdown_items_div ml-1">

                            {DLink1(currentLocation, "Vehicles Management", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.VEHICLE}`, Education_svg, "vehicles-lisitng-1", 'vehicles-list-collapse-btn')}


                        </li>}

                    {haveAccess(access.suspicious) && <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Suspicious Activity", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.SUSPISIOUS}`, Education_svg, "suspicious-lisitng-1", 'suspicious-list-collapse-btn')}


                    </li>}

                    {haveAccess(access.messages) && <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Messages", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.MESSAGES}`, Education_svg, "messages-lisitng-1", 'messages-list-collapse-btn')}


                    </li>}



                    {haveAccess(access.finance) && <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Finance", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.FINANCE}`, Education_svg, "finance-lisitng-1", 'finance-list-collapse-btn')}


                    </li>}


                    {haveAccess(access.makeModel) && <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Vehicle Make/Model", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.VEHICLE_MAKE}`, Education_svg, "vehicle-make-1", 'adminSe-list-collapse-btn')}

                    </li>}
                </ul>
            </div>






            {/* ---- Settings Dropdown ---- */}
            {haveAccess(access.settings) && <div className="flex-shrink-0">
                <ul className="list-unstyled m-0">
                    <li>
                        <a
                            onClick={() => {
                                document.getElementById('dashboard-collapse')?.classList.remove('show');
                                setActiveMenu((pre) => ({
                                    ...pre,
                                    settings: !active_menu.settings
                                }));
                                setActiveTab('settings-collapse-btn');
                            }}
                            href="#!"
                            style={

                                Toggle
                                    ? !active_menu.settings
                                        ? { width: '60px', borderBottomRightRadius: '0px', paddingRight: "10px" }
                                        : { paddingRight: "10px" }
                                    : { paddingRight: "10px" }
                            }
                            className={`data-toggle sidebar_options_drop d-flex justify-content-between ${active_tab === 'settings-collapse-btn' ? 'active_tab' : ''} ${active_menu.settings ? 'active_tab' : ''}  m-0 w-100`}
                            role="button"
                            id="settings-collapse-btn"
                            data-bs-toggle="collapse"
                            data-bs-target="#settings-collapse"
                            aria-expanded="true"
                        >
                            <div>
                                <img src={Education_svg} className="Sidebar_text sidebar_icons" alt="" />
                                <span className="text-dark" style={Toggle && !active_menu.settings ? { display: 'none', fontSize: "0.9rem" } : { fontSize: "0.9rem" }}>
                                    Settings
                                </span>
                            </div>
                            {!Toggle && <i className={`fas fa-chevron-down mr-3 ${active_menu.settings ? "toggle-up" : "toggle-down"}`}></i>}
                        </a>
                    </li>

                    <div className="collapse collapse_superadmin p-0  m-0 w-100" id="settings-collapse">
                        <ul className={`${Toggle ? 'btn-toggle-nav-hide' : 'btn-toggle-nav'} list-unstyled`}>
                            <li className="dropdown_items_div ml-1">
                                {DLink1(currentLocation, "Content Settings", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.HEADERSETTINGS}`, Education_svg, "content-settings-1", 'settings-collapse-btn')}
                                    </li>
                                    <li className="dropdown_items_div ml-1">
                                {DLink1(currentLocation, "FAQ Settings", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.FAQS}`, Education_svg, "faqs-settings-1", 'settings-collapse-btn')}
                            </li>

                            {/* ✅ GDPR Settings added here */}
                            <li className="dropdown_items_div ml-1">
                                {DLink1(currentLocation, "GDPR Settings", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.GDPR}`, Education_svg, "gdpr-settings-1", 'settings-collapse-btn')}
                            </li>


                            {/* ✅ Privcy Policy  Settings added here */}
                            <li className="dropdown_items_div ml-1">
                                {DLink1(currentLocation, "Privacy Policy", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.PRIVACY_POLICY}`, Education_svg, "privacy-settings-1", 'settings-collapse-btn')}
                            </li>



                            {/* ✅ Privcy Policy  Settings added here */}
                            <li className="dropdown_items_div ml-1">
                                {DLink1(currentLocation, "Terms And Conditions", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.TERMS_AND_CONDIIONS}`, Education_svg, "terms-settings-1", 'settings-collapse-btn')}
                            </li>




                            {/* ✅ Privcy Policy  Settings added here */}
                            <li className="dropdown_items_div ml-1">
                                {DLink1(currentLocation, "Payment Option", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.PAYMENT_OPTION}`, Education_svg, "payment-option-settings-1", 'settings-collapse-btn')}
                            </li>
                        </ul>
                    </div>
                </ul>
            </div>}




            {/* ---- Blog Dropdown ---- */}
            {haveAccess(access.blog) && <div className="flex-shrink-0">
                <ul className="list-unstyled m-0">
                    <a
                        onClick={() => {
                            document.getElementById('dashboard-collapse')?.classList.remove('show');
                            setActiveMenu((pre) => ({
                                ...pre,
                                blog: !active_menu.blog
                            }));
                            setActiveTab('blog-collapse-btn');
                        }}
                        href="#!"
                        style={Toggle ? !active_menu.blog ? { width: '60px', borderBottomRightRadius: '0px', paddingRight: "10px" } : { paddingRight: "10px" } : { paddingRight: "10px" }}
                        className={`data-toggle sidebar_options_drop d-flex justify-content-between ${active_tab === 'blog-collapse-btn' ? 'active_tab' : ''} ${active_menu.blog ? 'active_tab' : ''} m-0 w-100`}
                        role="button"
                        id="blog-collapse-btn"
                        data-bs-toggle="collapse" data-bs-target="#blog-collapse" aria-expanded="true"
                    >
                        <div>
                            <img src={Education_svg} className="Sidebar_text sidebar_icons" alt="" />
                            <span className="text-dark" style={Toggle && !active_menu.blog ? { display: 'none', fontSize: "0.9rem" } : { fontSize: "0.9rem" }}>Blog Management</span>
                        </div>
                        {!Toggle && <i className={`fas fa-chevron-down mr-3 ${active_menu.blog ? "toggle-up" : "toggle-down"}`}></i>}
                    </a>

                    <div className="collapse collapse_superadmin p-0  m-0 w-100" id="blog-collapse">
                        <ul className={`${Toggle ? 'btn-toggle-nav-hide' : 'btn-toggle-nav'} list-unstyled`}>
                            <li className="dropdown_items_div ml-1">
                                {DLink1(currentLocation, "Add Blog", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.ADD_BLOG}`, Education_svg, 'Add_Blog', 'blog-collapse-btn')}
                                {DLink1(currentLocation, "Blog Listing", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.BLOG}`, Education_svg, 'Blog_Listing', 'blog-collapse-btn')}
                            </li>
                        </ul>
                    </div>
                </ul>
            </div>}




            {haveAccess(access.about) && <div className="flex-shrink-0">
                <ul className="list-unstyled m-0">

                    <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "About Us", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.ABOUT_US}`, Education_svg, "about-us-lisitng-1", 'about-us-list-collapse-btn')}


                    </li>





                </ul></div>}


            {haveAccess(access.about) && <div className="flex-shrink-0">
                <ul className="list-unstyled m-0">

                    <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Car Review", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.CAR_REVIEW}`, Education_svg, "about-us-lisitng-1", 'about-us-list-collapse-btn')}


                    </li>





                </ul></div>}




            {haveAccess(access.contact) && <div className="flex-shrink-0">
                <ul className="list-unstyled m-0">

                    <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Contact Us", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.CONTACTUS}`, Education_svg, "contact-us-lisitng-1", 'contact-us-list-collapse-btn')}


                    </li>





                </ul></div>}




            {haveAccess(access.adReport) && <div className="flex-shrink-0">
                <ul className="list-unstyled m-0">

                    <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Ad Reports", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.ADREPORTS}`, Education_svg, "ad-report-lisitng-1", 'ad-report-list-collapse-btn')}


                    </li>





                </ul></div>}







        </div>



    );
};

export default SidebarLinks;